export default __webpack_public_path__ + "static/media/warning-icon.0a99c52e.svg";